import React, { Component } from 'react';
import { clearApiRetry, showApiMessages } from '../apiMessages';

export default class SiteHistoryMessages extends Component {
	componentDidMount() {
		this.showMessages();
	}

	componentDidUpdate({ response: prevResponse }) {
		if (this.props.response !== prevResponse) {
			this.showMessages();
		}
	}

	componentWillUnmount() {
		clearApiRetry('Site history');
	}

	showMessages() {
		showApiMessages({ ...this.props, title: 'Site history' });
	}

	render() {
		const { response = {} } = this.props;
		const { loading } = response;
		if (loading) return <p role="status">Loading site history...</p>;
		return null;
	}
}
